import * as React from "react";
import { Button, ButtonGroup, CircularProgress } from "@mui/material";

export default function AllStaffHeader(props) {
  let user = props.user;
  let language = props.language;
  let admin = props.admin;
  let advisoryData = props.advisoryData;
  let currentStudentEmail = props.currentStudentEmail;
  let handleDrawerToggle = props.handleDrawerToggle;
  let signInWithGoogle = props.signInWithGoogle;
  let signOut = props.signOut;
  let resetCurrentStudentEmail  = props.resetCurrentStudentEmail ;

  return (
    <header className="App-header" id="body">
      {(
        <ButtonGroup>
          {admin && false ? (
            <Button
              variant="contained"
              color="warning"
              target="_blank"
              onClick={() =>
                firebase.analytics().logEvent("page_view", {
                  page_title: "opened monthly points data studio report",
                })
              }
              href="https://lookerstudio.google.com/u/0/reporting/5c4c95c1-213b-4794-bf7a-a184ad75159d/page/p_igh1wmau3c"
            >
              Data Reports
            </Button>
          ) : null}
          {admin && advisoryData.length === 0 ? (
            <CircularProgress />
          ) : admin && currentStudentEmail.length > 0 ? (
            <Button
              variant="contained"
              color="secondary"
              //style={{ margin: "4%" }}
              onClick={() => resetCurrentStudentEmail()}
            >
              Re-select students
            </Button>
          ) : admin && advisoryData.length > 0 ? (
            <Button
              variant="contained"
              onClick={() => handleDrawerToggle(true)}
              color="secondary"
              //style={{ width: "100%", marginLeft: "-25%" }}
            >
              Step 1: Select students
            </Button>
          ) : null}
        </ButtonGroup>
      )}
    </header>
  );
}
